import React from 'react';
import Image from 'next/image';

interface Props {
  icon: string;
  title: string;
  value: string;
}

export function CardInfo(props: Props) {
  const { icon, title, value } = props;

  return (
    <div className="col-span-1 bg-slate-100 rounded-md px-4 py-2 flex justify-center items-center gap-3">
      <Image priority className="w-7 h-7" width={16} height={16} alt="" src={icon} />
      <div className="flex flex-col">
        <span className="typography-h6 font-medium text-gray-800 first-letter:uppercase">
          {title}
        </span>
        <b className="typography-h5 text-orange-600 font-bold first-letter:uppercase text-center">
          {value}
        </b>
      </div>
    </div>
  );
}
